import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ASSETS } from "@/lib/constants";

export default function CTASection() {
  return (
    <section className="relative grain overflow-hidden bg-forest py-28 lg:py-40" data-testid="cta-section">
      <div className="absolute inset-0 spotlight" />
      <img src={ASSETS.beetrootPiri} alt="" aria-hidden
        className="pointer-events-none absolute -left-10 top-1/2 hidden w-56 -translate-y-1/2 rotate-[-12deg] opacity-30 product-shadow lg:block" />
      <img src={ASSETS.plainTango} alt="" aria-hidden
        className="pointer-events-none absolute -right-10 top-1/2 hidden w-56 -translate-y-1/2 rotate-[12deg] opacity-30 product-shadow lg:block" />

      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center">
        <motion.h2 initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.9 }}
          className="font-display text-[15vw] leading-[0.9] tracking-tight text-cream sm:text-8xl lg:text-9xl">
          READY TO <span className="text-gold-gradient">CRUNCH</span> DIFFERENT?
        </motion.h2>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ delay: 0.3 }}>
          <Link to="/shop" data-testid="cta-shop-dignity"
            className="group mt-10 inline-flex items-center gap-2 rounded-full gold-gradient px-12 py-5 font-oswald text-base uppercase tracking-[0.2em] text-black transition-transform hover:scale-105">
            Shop Dignity <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
